import request from "@/utils/request";

async function baseRequest(path, payload, method) {
  return request({
    url: `/deployment-service/deployment/${path}`,
    method,
    data: method === "get" ? null : payload,
    params: method === "get" ? payload : null
  });
}

export function getFloors(payload) {
  return baseRequest("floors", payload, "get");
}

export function getPoints(payload) {
  return baseRequest("point", payload, "get");
}

export function bulkCreatePoint(payload) {
  return baseRequest("post_deployment_points", payload, "post");
}

export function deletePoint(payload) {
  return baseRequest("delete_deployment_point", payload, "post");
}

export function updateDeviceInfo(payload) {
  return baseRequest("post_device_info", payload, "post");
}
